import { PRINCIPAL_ROUTE_NAME } from "@router/principal";

const sv = {
  common: {
    preview: "Förhandsgranska",
    continue: "Fortsätt",
    next: "Nästa",
    previous: "Tidigare",
    complete: "Klar",
    skip: "Hoppa över",
    saveChanges: "Spara ändringar",
    save: "Spara",
    upload: "Ladda upp",
    uploadVideo: "Ladda upp video",
    loading: "Laddar",
    back: "Tillbaka",
    cancel: "Avbryt",
    delete: "Ta bort",
    close: "Stäng",
    twentyMinutes: "20 min",
    fiftyMinutes: "50 min",
    resetPasswordError: "Ett fel uppstod när lösenordet skulle återställas",
    notFoundEmailError: "En användare med denna e-postadress kunde inte hittas",
    email: "E-postadress",
    password: "Lösenord",
    passwordConfirm: "Bekräfta ditt lösenord",
    corporateEmail: "Ange din skol- eller organisationsmail",
    anyEmail: "Ange din e-postadress",
    today: "Idag",
    scheduleSession: "Boka ett elevhälsosamtal",
    invalidEmail: "Ogiltig e-postadress",
    invalidPasswordLength: "8 tecken långt",
    invalidPasswordMatch: "En stor bokstav, en liten bokstav & en siffra",
    invalidPasswordConfirm: "Lösenorden matchar inte",
    requiredField: "Detta fält är obligatoriskt",
    no: "Nej",
    checkSearch: "Lägg till en ny eller kontrollera om sökningen är korrekt",
    noFound: "Inga {{name}} hittades",
    switchAccountError: "Ett fel inträffade när du försökte byta organisation",
    dragNDrop:
      "Dra och släpp några filer hit, eller klicka för att välj filer.",
    continueWithCode: "Fortsätt med kod",
    continueWithoutCode: "Hoppa över",
    areYouSure: "Är du säker?",
    yes: "Ja",
    create: "Skapa",
    continue: "Fortsätt",
    keywordSearch: "Sök",
    watchHelloVideo: "Se videohälsning",
    helloVideoTitle: "Videohälsning",
    profileImage: "Profilbild",
    aboutMeVideo: "Videohälsning",
    notes: "Anteckningar",
    add: "Lägg till",
    color: "Färg",
    min: "min",
    send: "Skicka",
    selectStatus: "Välj en status",
    showMore: "Visa mer",
    showLess: "Visa mindre",
    download: "Ladda ner",
    downloadQrAsSvg: "Klicka och ladda ner QR som SVG",
    copied: "Kopierad",
    copyError: "Kunde inte kopiera",
    ok: "Okej",
    updateAvailable: "Uppdatering tillgänglig",
    updateAvailableDescription:
      "En uppdatering av Allbry finns tillgänglig. Uppdatera sidan för att få den senaste versionen.",
    refresh: "Uppdatera",
  },
  modal: {
    sizeLimit: {
      title: "Gränsen för filstorlek har nåtts",
      content:
        "Filen är för stor för uppladdning, gränsen är {{sizeLimit}}. Var vänlig välj en annan.",
    },
    fileType: {
      title: "Ogiltig filtyp",
      content: "Du kan bara använda bilder",
    },
    akkImage: {
      akkImage: "Bildstöd",
      customImage: "Egen bild",
      uploadImage: "Välj bild",
    },
    endDate: {
      title: "Slutdatum",
      content: "Välj slutdatum",
    },
  },
  mobile: {
    notAvailable: "Webbversionen av Allbry är inte tillgänglig på mobilen",
    availableInLandscape:
      "Allbry-webbversionen är endast tillgänglig i liggande läge",
    pleaseUseLinks: "Ladda ner vår mobilapp via länken nedan",
    pleaseUseLinksLandscape:
      "Du kan ladda ner vår mobilapp genom att använda länken nedan",
    appStore: "App Store",
    googlePlay: "Google Play",
  },
  introduction: {
    getSupport: "Elevhälsa direkt på webben",
    chat: {
      student: "Aden",
      counsellor: "Alexandra",
      messages: {
        first: "Hej!",
        second: "Jag känner mig nere",
        third: "Och har ingen att prata med... 😔",
        fourth:
          "Tja Aden! Du har ju mig att prata med! Berätta för mig, varför känner du dig nere?",
      },
    },
  },
  auth: {
    login: {
      withEmail: "Ange din e-postadress",
      enterPassword: "Ange ditt lösenord",
      codeStepTitle: "Har du fått en registreringskod?",
      loginSuccess: "Du har loggat in framgångsrikt",
      codeStepSubtitle:
        "I vissa fall behöver du en registreringskod för att registrera dig. Om du har fått en, vänligen ange den nedan. Om inte, tryck bara på hoppa över.",
      codeInput: "Registreringskod",
      codeInputHint: "Vänligen ange din registreringskod om du fått en",
      createPass: "Skapa ditt lösenord",
      terms: "Jag har läst, förstått och godkänner härmed Allbrys",
      termsLink: "villkor",
      paymentTitle: "Förnya din prenumeration",
      paymentDescription:
        "Allbry kostar {{price}} {{currency}} varje månad. Abonnemanget är aktivt tills du säger upp det.",
    },
    logout: {
      logoutSuccess: "Du har loggat ut framgångsrikt",
    },
    signUpConsumer: {
      terms: "Jag har läst, förstått och godkänner härmed Allbrys ",
      termsLink: "villkor",
      startJourney: "Påbörja din resa med Allbry idag",
      withOrganization: "Registrera dig med ett organisationskonto (SSO)",
      withEmail: "Skapa konto",
      signUp: "Registrera dig med e-postadress",
      createPass: "Skapa lösenord",
      haveAccount: "Har du redan ett konto?",
      logIn: "Logga in",
      connectedOrganization: "Ditt konto tillhör ",
      aboutYourSelfHeader: "Välj användarnamn",
      aboutYourSelfDescription1:
        "Välj det namn du vill ska synas för kuratorn eller rådgivaren.",
      aboutYourSelfDescription2:
        "Vi lämnar inte ut din personliga information till tredje part.",
      paymentTitle: "Skapa abonnemang",
      paymentDescription:
        "Allbry kostar {{price}} kr per månad och du debiteras månadsvis i efterhand så länge du har ditt konto hos oss. Snabbt och enkelt, utan bindningstid.",
      paymentDescriptionSuccess:
        "Grattis! Ditt konto är nu skapat och abonnemanget är aktivt tills att du avbryter det.",
      successTitle: "Grattis!",
      successDescription:
        "Välkommen till Allbry! Här finns vi tillgängliga för att stötta, motivera och vägleda dig. ",
      klarnaLoadingError:
        "Något gick fel när vi försökte ladda betalningsomdulen, var vänlig försök igen senare",
      klarnaOrderError:
        "Något gick fel när vi försökte bekräfta din betalning, var vänlig försök igen senare",
    },
    forgot: {
      checkStep: "Kolla din e-post!",
      weJustSent: "Vi har skickat en",
      resetPassLink: "återställningslänk för ditt lösenord",
      followInstructions:
        "till din e-post. Kolla din inkorg och följ instruktionerna",
      enterEmail: "Ange din e-postadress",
      createNewPass: "Skapa nytt lösenord",
    },
    registrationError: "Det gick inte att skapa ditt konto",
    signInError: "Felaktigt e-postadress och/eller lösenord",
    forgotPassword: "Glömt lösenord?",
    invalidPassword: "Ogiltigt lösenord",
    externalJoin: {
      title: "Har du fått en möteskod",
      description:
        "Om du har fått en möteskod, vänligen ange den nedan för att komma igång.",
      placeholder: "Ange din möteskod",
      help: "Kontakta organisatören om du inte har en möteskod.",
      invitationMessage: "Du har blivit inbjuden till ett möte",
      invitationDescription:
        "Du har blivit inbjuden till ett möte genom Allbry av {{counselorName}}",
    },
  },
  navbar: {
    switch: "Ställ dig själv som",
    toOffline: "offline",
    toOnline: "online",
    appointments: {
      title: "Samtal",
      text: "Boka ett videosamtal med elevhälsan för ett personligare samtal.",
    },
    messages: {
      title: "Chatt",
      text: "Chatta med elevhälsan när som helst utan att boka tid",
    },
    students: {
      title: "Elever",
    },
    reports: {
      title: "Rapporter",
    },
    home: {
      title: "Hem",
    },
    organizations: {
      title: "Organisationer",
    },
    profile: "Profil",
    settings: {
      title: "Inställningar",
    },
    logOut: "Logga ut",
    [PRINCIPAL_ROUTE_NAME.ORGANIZATION]: {
      title: "Organisation",
    },
    [PRINCIPAL_ROUTE_NAME.STATISTICS]: {
      title: "Statistik",
    },
    [PRINCIPAL_ROUTE_NAME.USERS]: {
      title: "Användare",
    },
    counsellors: {
      title: "Elevhälsopersonal",
    },
    dataMigration: {
      title: "Data Migration",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
    },
    configForm: {
      title: "Config Form",
    },
    notifications: {
      title: "Notifikationer",
    },
    superActions: {
      title: "Super Actions",
    },
    checkInsAndSurveys: {
      title: "Tempen",
    },
    config: {
      title: "Tempen",
    },
    broadcastMessages: {
      title: "Sänd meddelanden",
    },
    customReports: {
      title: "Rapporter",
    },
  },
  notFound: {
    code: "404",
    text: "Sidan gick inte att visa",
  },
  settings: {
    title: "Inställningar",
    billing: {
      title: "Prenumerationsinställningar",
      activeStatus:
        'Din prenumeration är <b class="text-green">aktiv</b> och nästa betalning kommer att inträffa den <b>{{date}}</b>',
      inactiveStatus:
        'Din prenumeration är <b  class="text-red">inaktiv</b>, men ditt konto är tillgängligt till <b>{{date}}</b>',
      manageSubBtn: "Hantera prenumeration",
      cancelSubBtn: "Avbryt prenumeration",
      manageSub: "Hantera prenumeration",
      cancelSub: "Avbryt prenumeration",
      cancelSubSubtitle:
        "Är du säker på att du vill lämna oss? Vi finns alltid här som stöd. Du är självklart välkommen tillbaka närsomhelst! Ditt konto kommer vara fortsatt aktivt fram till {{date}}, sedan säger vi hejdå.",
      confirmCancel: "Bekräfta",
    },
    anonymous: {
      title: "Anonymt läge",
      description:
        "Din organisation tillåter dig att vara anonym. Med denna inställning aktiverad kommer ditt namn och profilbild vara dolt för din elevhälsopersonal. Vi har anmälningsskyldighet i fall vi känner oss oroliga för dig och din omedelbara säkerhet så kan vi identifera dig, även om du är anonym.",
    },
    allowEmailNotification: {
      title: "Mejlnotiser",
      description: "Du kan stänga av mejlnotiser från Allbry",
    },
    calendarSync: {
      title: "Extern kalender synk",
      description: "Aktivera extern kalender synk för boka samtal",
      freeDescription: "Aktivera extern kalendersynk av upplagd tillgänglighet",
      freeNote:
        "Notera: Oftast läggs allt till automatiskt men om det inte sker så följ instruktionerna i mejlet som skickas till dig när du lägger till tillgänglig tid",
    },
    dataReset: {
      recurrentReset: {
        title: "Återkommande återställning av data",
        disabledResetParagraph:
          "Aktivera återkommande återställning av data för att rensa data automatiskt. Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        enabledResetParagraph:
          "Beräknat datum för nästa återställning är {{date}}. Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        intervalLabel: "Intervall",
        intervals: {
          eachMonth: "Varje månad",
          eachThreeMonths: "Varje 3 månader",
          eachSixMonths: "Varje 6 månader",
        },
        errorGettingResetState:
          "Fel när det gäller att hämta status för aktuella återkommande jobb",
        errorSwitchingResetState:
          "Fel vid ändring av status för återkommande jobb",
        errorIntervalChange: "Fel vid ändring av återställningsintervallet",
        successIntervalChange:
          "Ett nytt återställningsintervall har fastställts.",
      },
      manualReset: {
        title: "Återställ data nu",
        paragraph:
          "Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        resetButton: "Rensa alla uppgifter",
        resetSuccess: "Uppgifterna har raderats",
        resetFailure: "Fel vid återställning av data",
        resetModal: {
          title: "Rensa alla uppgifter",
          paragraph:
            "Är du säker på att du vill återställa all information i chattar, samtalshistorik och minnesanteckningar?",
          yes: "Ja",
          no: "Nej",
        },
      },
    },
    policy: {
      title: "Integritetspolicy",
      description: {
        firstPart: "",
        secondPart: "",
      },
      policyCopy:
        "En kopia av våra användarvillkor och integritetspolicy finns",
      hereLink: "här",
    },
    language: {
      title: "Språk",
    },
    changePassword: "Ändra Lösenord",
    currentPassword: "Nuvarande Lösenord",
    newPassword: "Nytt Lösenord",
    confirmPassword: "Bekräfta Nytt Lösenord",
    passwordChanged: "Lösenordet har ändrats",
    unavailable: {
      title: "Out of office",
      description:
        "Fyll i rutan nedan och aktivera till höger för att ställa in ett meddelande som visas för dina elever när de skickar ett meddelande till dig.",
      success: "Texten har uppdaterats",
      unavailableText: "Ange texten här",
      anywaySendMessage:
        "Ge eleven möjlighet att fortsätta skicka meddelanden även om du inte är tillgänglig.",
    },
  },
  profile: {
    personProfile: "{{type}}s profil",
    personProfileName: "{{person}}s profil",
    overview: "Profil",
    edit: {
      title: "Ändra profil",
      restriction: "Endast administratörer kan ändra",
      gender: {
        male: "Man",
        female: "Kvinna",
        other: "Annat",
        private: "Vill inte svara",
      },
      about: "Om",
      changesSaved: "Ändringar sparade",
    },
    personalInfo: "PERSONLIGA UPPGIFTER",
    about: "Om mig",
    name: "Namn",
    birthday: "Födelsedatum",
    fullBirthday: "{{birthday}} ({{fullYears}} år)",
    appointments: "SAMTAL",
    noAppointments: "Inga samtal hittades för denna kategori",
    gender: "Kön",
    age: "Ålder",
    email: "E-postadress",
    lastNote: "{{person}}s senaste anteckning kommer visas här.",
    parentAccountID: "Parent account ID",
    noParentIfEmpty: "Ingen parent om den är tom",
    secretIdentity: "Skyddad identitet",
  },
  appointments: {
    title: "Samtal",
    session: {
      today: "Gå med i samtalet",
      future: "Avbokning eller ombokning",
      completed: "Nytt samtal",
      cancelled: " Nytt samtal",
      cancel: "Avboka",
    },
    status: {
      upcoming: "Kommande",
      completed: "Avslutade",
      cancelled: "Avbokade",
      unanswered: "Väntar på svar från {{name}}",
      pending: "Väntar på svar från dig",
      active: "Accepterad",
    },
    action: {
      accept: "Godkänn",
      reschedule: "Ombokning",
      deny: "Avböj",
      goToAppointment: "Gå till bokningen",
    },
    unansweredDialog: {
      title: "Du har obesvarande samtalsförfrågningar",
      continueBtn: "Fortsätt senare",
    },
    booking: {
      title: {
        booking: "Bokning",
        reschedule: "Omplanera",
      },
      schedule: "Boka",
      chooseStudent: "Välj elev",
      selectStudent: "Välj elev",
      chooseUser: "Välj användare",
      selectUser: "Välj användare",
      sessionDuration: "Samtalets längd",
      sessionTime: "Samtalets tid",
      success: "Klart",
      successText: "Du kan se din bokning under kommande samtal",
      successBooked: "bokat",
      successRescheduled: "ombokat",
      back: "Okej",
      chooseUserModal: "Välj användare",
      chooseStudentModal: "Välj elev",
      done: "Klart",
      chooseCounsellor: "Välj elevhälsopersonal",
      chooseCounsellorModal: "Välj elevhälsopersonal",
      selectCounsellor: "Välj elevhälsopersonal",
      searchStudents: "Sök elev",
      recommendedSlotsMassage:
        "Inga tillgängliga tider, välj ett annat datum eller välj en av de rekommenderade tiderna nedan",
      recommendedSlots: "Rekommenderade tider",
      noTimeSlots: "Inga tillgängliga tider",
      custom: "Anpassad tid",
      startTime: "Starttid",
      endTime: "Sluttid",
      video: "Video",
      students: "Elever",
      counsellors: "Elevhälsopersonal",
      search: {
        student: "Sök elev",
        counsellor: "Sök hälsopersonal",
      },
      notFound: {
        student: "Ingen elev hittades",
        counsellor: "Ingen elevhälsopersonal hittades",
      },
      selectExternal: "Lägg till extern",
      name: "Namn",
      number: "Telefonnummer",
      email: "Epost",
    },
    detail: {
      scheduleInfoCancelOrReschedule:
        "Samtalet är bokat per {{date}}, klockan {{time}}. Du kan närsomhelst avboka eller omboka samtalet. ",
      scheduleInfoBookAnother:
        "Samtalet är bokat per {{date}}, mellan kl {{start}} - {{end}}. Du kan alltid boka flera samtal.",
      reschedule: "Omboka",
      cancel: "Avboka",
      areYouSure: "Är du säker på att du vill avboka ditt samtal?",
      yes: "Ja, avboka",
      cancelled: "Samtalet är avbokat",
      sessionDetails: "Samtalets detaljer",
      externalUserInfo: "Extern användarinformation",
      copied: "Kopierad",
      copyError: "Kunde inte kopiera",
      resendEmailToExternalUser:
        "Är du säker på att du vill skicka e-postmeddelandet igen till den externa användaren?",
    },
    now: "Nu",
    scheduleNew: "Nytt samtal",
    counsellors: "Hej, snacka med mig!",
    appointments: "Samtal",
    seeAll: "Se alla",
    notExist: "Samtalet finns inte",
    weeksInterval: "Om {{interval}} veckor",
    daysInterval: "Om {{interval}} dagar",
    dayInterval: " Om {{interval}} dag",
    hoursInterval: " Om {{interval}} timmar",
    hourInterval: " Om {{interval}} timme",
    minutesInterval: " Om {{interval}} minuter",
    minuteInterval: " Om {{interval}} minut",
    today: "Idag",
    future: "Framtiden",
    completed: "Avslutad",
    cancelled: "Avbokad",
    organizationNotWorking: "Organisationen arbetar inte denna dag",
    noAppointments: "Inga samtal här ännu...",
    scheduleFirst: "Boka ditt första samtal",
    yourFreeTime: "Din tillgänglighet",
    freeTime: {
      title: "Din tillgänglighet",
      addTime: "Lägg till tid",
      noFreeTimes:
        "Här avsätter du dina tillgängliga tider för samtal. Under dessa tider kan du boka in elever på individuella samtal och eleverna kan även boka dig.",
      allocateTime: "Bokningsbar tid",
      startTime: "Starttid",
      endTime: "Sluttid",
      editTime: "Redigera tillgänglig tid",
      add: "Lägg till",
      cancel: "Annullera",
      date: "Datum",
      ends: "Slutar",
      orgNotWorking: "Organisationen har inte öppet",
      repeats: {
        everyday: "Varje dag",
        weeklyOn: "Varje vecka på {{day}}",
        weekdays: "Varje vardag (måndag till fredag)",
        none: "Upprepas inte",
      },
      deleteModal: {
        title: "Ta bort tillgänglig tid",
        description: "Är du säker på att du vill ta bort din tillgängliga tid?",
        delete: "Ja, ta bort",
      },
      timeAdded: "Din tillgängliga tid lades till",
      timeEdited: "Din tillgängliga tid har redigerats",
      timeDeleted: "Din tillgängliga tid raderades",
    },
    customMeeting: "Välj mötestyp",
    error: {
      studentOrCounsellor:
        "Elev eller personal är inte tillgänglig mellan {{data}}",
      and: "och",
      counsellor: "Personal är inte tillgänglig denna tid",
      timeError: "Sluttiden måste vara större än starttiden",
      minimumTime: "Samtalet måste vara längre än {{minimumTime}} minuter",
      currentTime: "Starttiden måste vara större än aktuell tid",
      noAvailableTime: "Elev eller personal är inte tillgänglig för närvarande",
    },
    invited: "{{count}} inbjudna",
    participants: "{{count}} deltagare",
  },
  notes: {
    title: "Anteckningar & rapporter",
    note: "Anteckning",
    report: "Elevrapport",
    topics: "Ämnen",
    meetingType: "Mötestyp",
    meetingKind: "Mötesplats",
    meetingDuration: "Möteslängd",
    student: "Elev",
    generated: "Genererad",
    add: "Skapa anteckning",
    personNotes: "{{person}}s anteckningar & rapporter",
    personNote: "{{person}}s anteckning",
    personReport: "{{person}}s rapport",
    personStatistics: "{{person}}s Statistik",
    create: "Skapa ny anteckning",
    saveText:
      "Skapa minnesanteckningar för eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet.",
    autoSaveText:
      "Skapa minnesanteckningar för eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet. Anteckningarna sparas automatiskt. ",
    autoSaveTextDuringVideo:
      "Skapa minnesanteckningar för eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet. Anteckningarna sparas automatiskt.",
    metaAppointment:
      "{{person}} har avslutat ett samtal med {{student}}, {{date}}",
    metaChat:
      "{{person}} har avslutat en chattkonversation med {{student}}, {{date}}",
    createdBy: "{{date}} av {{person}}",
    delete: "Ta bort anteckningen",
    deleteQuestion: "Är du säker på att du vill ta bort den här anteckningen?",
    yes: "Ja, ta bort",
    saved: "Anteckningen har sparats",
    deleted: "Anteckningen har raderats",
    worryLevel: "Orosnivå",
    filter: "Filter",
    notes: "Anteckningar",
    reports: "Rapporter",
    isPinned: "Fäst anteckning",
    pinnedNotes: "Den här anteckningen är fäst",
    isNotPinned: "Den här anteckningen är inte fäst",
    isPublic: "Öppen",
    isForPublic:
      "Denna anteckningen är synlig för kollegor med andra professioner",
    isNotForPublic:
      "Denna anteckningen är inte synlig för kollegor med andra professioner",
    publicLabel: "Öppen",
    pinnedLabel: "Fäst",
    isForReportPublic:
      "Denna rapport är synlig för kollegor med andra professioner",
    isReportNotForPublic:
      "Denna rapport är inte synlig för kollegor med andra professioner",
  },
  videoCall: {
    leaveCallModal: {
      title: "Avsluta samtalet",
      paragraph:
        "Har du redan gjort ditt samtal? Klicka i så fall på avsluta samtalet och fyll i rapporten. Om inte, klickar du på Lämna samtalet så kan du återgå till samtalet.",
      leaveCall: "Lämna samtalet",
      endCall: "Avsluta samtalet",
    },
    videoAccessModal: {
      title: "Kameran eller mikrofonen är blockerad",
      description_1:
        "Allbry kräver åtkomst till din kamera och mikrofon. Klicka på ikonen för blockerad kamera",
      description_2: "i webbläsarens adressfält.",
      leaveCall: "Lämna samtalet",
    },
    join: "Ansluten",
    notJoin: "Ej ansluten",
  },
  chat: {
    end: "Avsluta chatt",
    archivedForCounsellor:
      "Eleven har arkiverat chatten. Det betyder att chatten är rensad för eleven och den ser inte tidigare meddelanden. För att starta om konversationen behöver du bara skriva något.",
    endInfoForCounsellor:
      "Chatten avslutades kl {{time}} av dig. Skriv ett meddelande för att starta chattkonversationen på nytt. ",
    noMessages: "Vad tänker du på?",
    sendFirstMessage: "Skriv vad som helst för att börja!",
    writeMessage: "Skriv ett meddelande...",
    endChatQuestion:
      "Är du säker på att du vill avsluta chatten? Chatten kommer inte försvinna och du kan närsomhelst starta den igen genom att skicka ett nytt meddelande.",
    attachmentInfo: "{{fileSize}}, {{date}} kl {{time}}",
    sharedFiles: "DELADE FILER",
    noFiles: "Inga filer har delats än...",
    general: "Alla",
    messages: "Meddelanden",
    chatEnded: "(Chatt avslutad)",
    attachment: "(Bilaga)",
    image: "(Bild)",
    startTitle: "Vem vill du chatta med?",
    noStudentsFound: "Inga elever hittades",
    notFoundLabels: {
      student: "Ingen elev hittades",
      counsellor: "Ingen elevhälsopersonal hittades",
      globalCounsellor: "Ingen global studenthälsopersonal hittades",
    },
    noStudentsAvailable: "Inga elever är tillgängliga",
    noStudentsAvailableToChat:
      "Det finns inga tillgängliga elever att starta en chatt med",
    noCounsellorsAvailable: "Ingen elevhälsopersonal är tillgänglig",
    noCounsellorsAvailableToChat:
      "Det finns ingen tillgänglig elevhälsopersonal att starta en chatt med",
    start: "Starta chatt",
    startGroupChat: "Starta gruppchatt",
    nameTheGroupChat: "Namnge gruppchatten",
    enterGroupName: "Ange ett namn för gruppchatten",
    groupName: "Gruppens namn",
    more: "Se mer",
    selectChat:
      "Välj en chatt och skicka ett meddelande eller skriv ett nytt meddelande.",
    archive: "Arkiverat",
    delete: "Ta bort chatt",
    organizationDoesntWork:
      "Allbry är inte öppet just nu. Du kan självklart fortfarande skicka ditt meddelande så svarar vi så fort vi kan. Vi har öppet och elevhälsopersonal finns på plats mellan {{start}} och {{end}}.",
    organizationDoesntWorkToday:
      "Skolan är stängd över sommaren. Det kommer att ta längre tid att få svar, men på mobilen har du fortfarande tillgång till flera olika stödlinjer.",
    endInfoForStudent:
      "Chatten avslutades kl {{time}} av {{person}}. Du kan närsomhelst starta den igen genom att skicka ett nytt meddelande.",
    sendAfterWork: "Skicka meddelande utanför Allbrys öppettider",
    workingHours:
      "Allbry har öppet mellan {{start}} och {{end}}. Du kan självklart fortfarande skicka ditt meddelande så svarar vi så fort vi kan.",
    workingHoursToday:
      "Organisationen har inte öppet idag. Du kan skicka meddelanden utanför arbetstid, observera dock att du får svar inom arbetstid.",
    ok: "Jag förstår",
    deleteChatQuestion: "Är du säker på att du vill ta bort chatten? ",
    archiveChat: "Arkivera chatt",
    unarchiveChat: "Återställ chatt",
    deleted: "Chatten raderad",
    archived: "Chatten arkiverad",
    unarchived: "Chatten har återställts",
    deleteGroup: "Ta bort grupp",
    modifyGroup: "Ändra grupp",
    groupAllMembers: "Gruppmedlemmar",
    modifyGroupChat: "Redigera gruppchatt",
    editGroupName: "Ange ett namn för gruppchatten",
    members: "Deltagare",
    confirmToDelete: "Är du säker på att du vill ta bort gruppen?",
    confirmToDeleteMember: "Är du säker på att ta bort vald deltagare?",
    addNewMember: "Lägg till deltagare",
    deleteSelected: "Ta bort vald deltagare",
    selectNewMember: "Välj deltagare",
    selectClose: "Välj & stäng",
    noMembersInGroup:
      "Det finns inga medlemmar i den här gruppen. Vill du ta bort gruppen?",
    groupMembers: "{{value}} deltagare",
    overview: "Översikt",
    notesAndReports: "Anteckningar & rapporter",
    statistics: "Statistik",
    imageFile: "Bild eller bilaga",
    akkImage: "Bildstöd",
    read: "Läst",
    akk: {
      selectCategory: "Välj kategori",
      chooseAkk: "Välj bilder",
      send: "Skicka",
      noImage: "Inga bilder hittades",
    },
    all: "Alla",
    students: "Elever",
    counsellors: {
      shortName: "Lokala",
      fullName: "Elevhälsopersonal på skolan",
    },
    globalCounsellors: {
      shortName: "Globala",
      fullName: "Elevhälsopersonal inom organisationen",
    },
    searchStudent: "Sök elev",
    searchCounsellor: "Sök elevhälsopersonal",
    searchGlobalCounsellor: "Sök global elevhälsopersonal",
    active: "Registrerad",
    inactive: "Inaktiv",
    deactivated: "Inaktiverad",
    successDelete: "Meddelandet har raderats",
    counsellorUnavailable: "Personal är inte tillgänglig",
    videoCall: "Videosamtal",
    confirmVideoCall: "Är du säker på att du vill starta ett videosamtal?",
    counsellorInactive: "Personen arbetar inte längre på skolan",
    onlyAllbryCanSendMessage: "Endast {{name}} kan skicka meddelanden",
    messagesTitleSuperAdmin: "Meddelanden (tekniska releaser)",
    showMore: "Visa mer",
  },
  reports: {
    createReport: "Skapa elevrapport",
    deleteReport: "Ta bort rapport",
    deleteReportQuestion: "Är du säker på att du vill ta bort rapporten?",
    yes: "Ja, radera",
    deleted: "Rapporten har raderats",
    title: "Elevrapport",
    title2: "Friviligt steg",
    selectDate: "1. Datum",
    selectTopics: "2. Vilka ämnen har berörts under samtalet?",
    concernScale: "3. Hur orolig är du för eleven?",
    selectMeetingType: "4. Vad för typ av samtal har ni haft?",
    selectMeetingKind: "5. Hur ägde samtalet rum?",
    noteComment: "{{questionNo}}. Anteckning / Kommentar",
    feedbackAllbry:
      "{{questionNo}}. Finns det något annat du vill kunna kartlägga? (valfri marknadsundersökning)",
    additionalSupportQuestionTitle:
      "{{questionNo}}. Är eleven i behov av ytterligare stöd?",
    participationThanks: {
      title: "Tack!",
      details:
        "Tack för att du fyllt i elevrapporten. Dessa används för att kunna få insikt i hur eleverna mår och vad dem pratar om för att göra en bra kartläggning av eleverna.",
      close: "Stäng",
    },
    topics: {
      startOfSession: "Sökt kontakt (startat samtal)",
      checkIn: "Check-in",
      basicCare: "Grundläggande omsorg",
      identity: "Identitet",
      anxiety: "Ångest",
      stress: "Stress",
      physicalHealth: "Fysisk hälsa",
      training: "Träning",
      crime: "Kriminalitet",
      sorrow: "Sorg",
      socialRelationship: "Sociala relationer",
      workLife: "Arbetsliv",
      shame: "Skam",
      honor: "Heder",
      careFailure: "Omsorgssvikt",
      economy: "Ekonomi",
      security: "Säkerhet",
      stimulationAndGuidance: "Stimulans och vägledning",
      socialOrientation: "Samhällsorientering",
      emotionalAvailability: "Känslomässig tillgänglighet",
      love: "Kärlek",
      mentalHealth: "Psykisk hälsa",
      mentalAbuse: "Psykisk misshandel",
      physicalAbuse: "Fysisk misshandel",
      loveRelations: "Kärleksrelationer",
      familyRelations: "Familjerelationer",
      sexualAbuse: "Sexuellt övergrepp",
      economicalAbuse: "Ekonomisk misshandel",
      drugUse: "Droganvändning",
      performanceAnxiety: "Prestationsångest",
      loneliness: "Ofrivillig ensamhet",
      grooming: "Grooming",
      school: "Skola",
      education: "Utbildning",
      selfHarm: "Självskadebeteende",
      suicidalToughts: "Självmordstankar",
      religion: "Religion",
      politics: "Politik",
      sexuality: "Sexualitet",
      npfDiagnoses: "NPF-diagnoser",
    },
    meetingType: {
      emergencyMeeting: "Akutmöte",
      dropInMeeting: "Drop-in möte",
      individualMeeting: "Enskilt möte",
      noShowMeeting: "Uteblivet möte",
      parentMeeting: "Möte med vårdnadshavare",
      ehtMeeting: "Möte med representant från EHT",
      groupMeeting: "Gruppmöte med elever",
      adultMeeting: "Möte med annan vuxen (t.ex. lärare)",
      breakMeeting: "Samtal i korridor eller under rast",
      adultStudentMeeting:
        "Samtal med elev, VH, rektor och / eller annan skolpersonal",
    },
    meetingKind: {
      allbryMeeting:
        "Bokade du ett fysiskt möte eller videosamtal genom Allbry?",
      allbryMeetingIfNot: "Om inte, ange vilken typ av möte du haft",
      telephone: "Telefonmöte",
      digital: "Digitalt möte",
      physical: "Fysiskt möte",
    },
    addTopic: {
      title: "Lägg till ämne",
      name: "Namn",
      description: "Beskrivning",
      button: "Lägg till ny",
      success: "Ämnet har lagts till",
      error: "Det gick inte att lägga till ämne",
      expandTab: "Expandera",
      collapseTab: "Kollapsa",
      all: "Alla",
    },
    worriedLevel: {
      level0: "Ingen oro / sökt kontakt",
      level0_5: "Risk på väg mot nivå 1 ",
      level1:
        "Förebyggande / främjande / informerande samtal eller övriga samtal",
      level1_5: "Risk på väg mot nivå 2",
      level2: "Mild oro – oro som du kan hantera med eleven",
      level2_5: "Risk på väg mot nivå 3",
      level3:
        "Medel oro - kontakta skolan och uppföljning efter 4 veckor eller hänvisa till BUP / psykiatrin & andra instanser",
      level3_5: "Risk på väg mot nivå 4",
      level4: "Hög oro – orosanmälan eller liknande",
      level4_5: "Risk på väg mot nivå 5",
      level5: "Akut oro - agera nu, larma till räddningstjänst eller liknande",
      details0:
        "Ingen oro / sökt kontakt \n\nIngen oro vid det här stadiet. Eleven har sökt kontakt eller startat ett samtal. ",
      details0_5: "Risk på väg mot nivå 1.",
      details1:
        "Förebyggande / främjande / informerande samtal eller övriga samtal \n\nVid den här nivån har elevhälsopersonal haft förebyggande/främjande/informerande samtal eller andra typer av stödsamtal. Exempelvis om vänskapsrelationer, kärlek, framtid och fritid eller mål och drömmar och liknande teman/ämnen.\n\nVägledande samtal i samband med exempelvis gymnasieansökan (för grundskoleelever) eller universitetsansökan (för gymnasieelever). ",
      details1_5: "Risk på väg mot nivå 2.",
      details2:
        "Mild oro – oro som du kan hantera med eleven \n\nVid den här nivån känner elevhälsopersonal en mild oro för eleven. Det innebär oro där kurator/elevhälsopersonal och elev kan samtala om ämnen/teman utan att behöva meddela andra (tystnadsplikt). Det kan gälla samtal om självkänsla, självförtroende, tidigare trauman, relationer och hälsa och erfarenheter som eleven berättar om.\n\nI det här stadiet av oro kan kurator/elevhälsopersonal med sina färdigheter, kunskaper och samtalsmetoder arbeta med eleven och stötta vid olika lägen och situationer. \n\nRelationsskapande, förtroende och tillit är viktiga i denna nivå då en elev kanske berättar något i förtroende till elevhälsopersonal som eleven inte vill ska komma ut till någon annan men som ändå behöver hjälp, ett exempel är låg självkänsla, berättar om NPF-diagnoser, utredningar, tidigare kontakt med myndigheter som socialtjänst och BUP eller vuxenpsykiatrin.\n\nDet finns en oro för eleven men du som elevhälsopersonal finns som stöd och reder ut oron.",
      details2_5: "Risk på väg mot nivå 3.",
      details3:
        "Medel oro - kontakta skolan och uppföljning efter 4 veckor eller hänvisa till BUP / psykiatrin & andra instanser \n\nDetta är det första steget där elevhälsopersonal ska agera och bryta mot sekretessen (tystnadsplikt). I det här fallet handlar det om att kontakta skolan vid oro kring barnets hälsa (psykisk och fysisk hälsa), skolgång, skolresultat, hemmamiljö, utfrysning och mobbning. Kränkande behandling. Vid första steg kontaktas kurator eller mentor. Eventuellt ett ärende för EHT/EHM att diskutera denna elev exempelvis vid anpassningar, svårigheter i skolan. Uppföljning för eleven sker efter 4 veckor, kurator ansvarar för uppföljning.",
      details3_5: "Risk på väg mot nivå 4.",
      details4:
        "Hög oro – orosanmälan eller liknande \n\nUtifrån Socialstyrelsens styrdokument samt anmälningsskyldighet enligt SoL 14kap 1§ & SkolL 29kap 13§, skyldighet att anmäla vid kännedom eller misstanke om att barn far illa. Elevhälsopersonal meddelar eleven (och föräldrarna i vissa fall) och informera om att en orosanmälan görs och varför den görs. Skolan skall alltid vara informerade. En orosanmälan görs vanligtvis i samarbete med rektor.\n\nSocialstyrelsens (2013) definition av begreppet ”barn som far illa” ur Barn som far illa eller riskerar att fara illa. En vägledning för hälso- och sjukvården samt tandvården gällande anmälningsskyldighet och ansvar.\n\n”Begreppet barn som far illa innefattar alla former av övergrepp, försummelse och utnyttjande som leder till faktisk eller potentiell skada för barnets hälsa eller utveckling. Det kan till exempel avse barn och ungdomar som i hemmet utsätts för fysiskt eller psykiskt våld, sexuella övergrepp, kränkningar eller problem i förhållande till sin familj, likaså om det blir vittne till våld eller lever i en miljö där våld och hot om våld förekommer. Vidare ingår barn och ungdomar som far illa på grund av sitt eget beteende, exempelvis på grund av missbruk, kriminalitet och annat självdestruktivt beteende. Barn som utsätts för hot, våld eller andra övergrepp från jämnåriga eller från andra, samt barn med stora problem i skolsituationen föranledda av en social problematik kan också anses ingå i socialtjänstens målgrupp.””Begreppet barn som far illa innefattar alla former av övergrepp, försummelse och utnyttjande som leder till faktisk eller potentiell skada för barnets hälsa eller utveckling. Det kan till exempel avse barn och ungdomar som i hemmet utsätts för fysiskt eller psykiskt våld, sexuella övergrepp, kränkningar eller problem i förhållande till sin familj, likaså om det blir vittne till våld eller lever i en miljö där våld och hot om våld förekommer. Vidare ingår barn och ungdomar som far illa på grund av sitt eget beteende, exempelvis på grund av missbruk, kriminalitet och annat självdestruktivt beteende. Barn som utsätts för hot, våld eller andra övergrepp från jämnåriga eller från andra, samt barn med stora problem i skolsituationen föranledda av en social problematik kan också anses ingå i socialtjänstens målgrupp.”",
      details4_5: "Risk på väg mot nivå 5.",
      details5:
        "Akut oro - agera nu, larma till räddningstjänst eller liknande \n\nAgera genast. Vid det här stadiet är det omedelbar fara för elevens liv eller hälsa, eller andra situationer där action måste genomföras genast. Ring 112. Kontakta räddningstjänst. Det kan vara att en elev skriver att den skall genomföra ett självmordsförsök, begå ett brott eller utsätta sig själv eller någon annan i omedelbar fara. ",
      title: "Information nivå ",
    },
    types: {
      quick: {
        title: "Snabb",
        description: "Endast ett begränsat antal ämnen",
        selectTopics: "1. Välj ämnet i konversationen",
        selectMeetingKind: "2. Hur ägde samtalet rum?",
      },
      normal: {
        title: "Normal",
        description: "Rapport i full längd",
      },
    },
    additionalSupport: {
      youthReception: "Ungdomsmottagning",
      socialServices: "Socialtjänst",
      medicalAndHealthcare: "Sjuk- och hälsovård",
    },
    statistics: {
      additionalSupport: "Ytterligare stöd",
    },
  },
  principal: {
    validation: {
      notEmpty: "Värdet kan inte vara tomt",
      noSpaces: "Värdet kan inte ha mellanslag",
      lessThan30Symbols: "{{value}} bör vara mindre än 30 tecken",
      exists: "Attributet finns redan",
      ageLessThan8: "Din ålder får inte vara lägre än 8 år",
      ageLessThan18: "Din ålder får inte vara lägre än 18 år",
      required: "{{value}} krävs",
      requiredName: "Namn krävs",
      requiredEmail: "E-postadress krävs",
      notValidEmail: "Inte giltig e-postadress",
    },
    addCustomField: "Lägg till ett anpassat fält",
    overview: "{{name}} Översikt",
    schedule: "Verksamhetsschema",
    addCustomAttributes: "Lägg till anpassade attribut",
    customFieldsDescription:
      "Du kan mäta och följa upp olika attribut, t.ex. årskurs eller klass.",
    anonymous:
      "Eleverna i din organisation får vara anonyma. Deras namn och profilbilder kommer att vara dolda för andra användare.",
    removeChatTitle: "Ta bort chattar",
    removeChatDescription:
      "Elever i din organisation får ta bort chattar med elevhälsopersonal.",
    archiveChatTitle: "Arkivera chattar",
    archiveChatDescription:
      "Eleverna i din organisation får arkivera chattar med elevhälsopersonal.",
    addCustomMeetingTypes: "Skapa anpassade mötestyper",
    addMeetingType: "Skapa anpassad mötestyp",
    createMeetingType: "Skapa mötestyp",
    editMeetingType: "Redigera mötestyp",
    chooseMeetingTypeEN: "Ange mötestypens namn på engelska",
    chooseMeetingTypeSW: "Ange mötestypens namn på svenska",
    meetingDescriptionSW: "Ange en beskrivning på svenska",
    meetingDescriptionEN: "Ange en beskrivning på engelska",
    videoEnable: "Video aktiverat",
    meetingCreated: "Mötestypen är skapad",
    errorCreateMeeting: "Det gick inte att skapa mötestypen",
    updatedMeeting: "Mötestypen är ändrad",
    errorUpdatingMeeting: "Det gick inte att uppdatera mötestypen",
    removeMeeting: "Mötestypen är borttagen",
    errorRemovingMeeting: "Det gick inte att radera mötestypen",
    MeetingNameRequired: "Namn på mötestypen är obligatoriskt",
    confirmRemoveMeeting: "Är du säker på att du vill ta bort mötestypen?",
    removePopup: "Är du säker på att du vill ta bort mötestypen?",
    video: "Video",
    editMeeting: "Redigera",
    to: "Till",
    from: "Från",
    workingHours: "Arbetstid",
    custom: "Anpassad",
    weekDays: "Veckodagar",
    allDays: "Alla dagar",
    appointmentTypeDescription:
      "Den initiala Videomötestypen försvinner om en ny videomötestyp läggs till",
    sessionDuration: "Välj samtalets varaktighetstid",
    sessionDurationNote:
      "Notera: Se till att du gör ett val, eftersom om inget alternativ är valt så kommer standardalternativen 20 minuter och 50 minuter väljas",
    days: {
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag",
      sunday: "Söndag",
    },
    startLaterThanEnd: "Starttiden är senare än sluttiden",
    endBeforeStart: "Sluttiden är före starttiden",
    edit: "Redigera användare",
    add: "Lägg till användare",
    student: "Elev",
    counsellor: "Kurator",
    allbryCounsellor: "Allbry Kurator",
    userCreated: "Användaren skapades framgångsrikt.",
    errorCreatingUser: "Fel vid skapande av användaren",
    userUpdated: "Användaren uppdaterades framgångsrikt.",
    errorUpdatingUser: "Fel vid uppdatering av användaren",
    userTable: {
      viewProfile: "Visa profil",
      editProfile: "Redigera profil",
      users: "användare",
      active: "Registrerad",
      inactive: "Inaktiv",
      deactivated: "Inaktiverad",
      nameSurname: "Namn Efternamn",
      birthday: "Födelsedatum",
      organization: "Organisation",
      activate: "Aktivera",
      deactivate: "Inaktivera",
      profileActivated: "Profil aktiverad",
      profileDeactivated: "Profilen är inaktiverad",
      activatingError: "Fel vid aktivering av profil",
      deactivatingError: "Fel vid avaktivering av profil",
      generateCsvTemplate: "Generera csv-mall",
      generateXlsxTemplate: "Generera xlsx-mall",
      importUsers: "Importera användare från xls eller xlsx",
      csvImportTitle: "Import pågår",
      csvImportBody:
        "Det kan ta lite tid att importera användare. Stäng inte fönstret",
      importButton: "Importera",
      selectFiles: "Välj den fil som ska importeras",
      importTitle: "Importera användare",
      usersAddSuccess: "Användare har lagts till",
      usersAddError: "Fel vid import av användare",
      wrongFormat: "Filformatet ska vara xls eller xlsx",
      wrongImportData: "Fel i rad {{row}}:\n{{error}}",
      validationError: "{{field}} ✑ {{error}}",
      onboardingEmailDialogInstruction:
        "Du kommer att skicka onboardingmejl till följande användare",
      inActivateMultipleUserDialogInstruction:
        "Du kommer att inaktivera följande användare",
      scrapeMultipleUserDialogInstruction:
        "Du kommer att ta bort följande användare",
      sendEmail: "Skicka mejl",
      onboardingEmail: "Onboardingmejl",
      customEmail: "Anpassat mejl",
      disableStudent: "Inaktivera elever",
      disableUser: "Inaktivera användare",
      actions: "Åtgärder",
      usersDelete: "Ta bort användare",
      requestScrapeSuccess: "Användarna är borttagna",
      changeAttributesSuccessMessage: "Attribut har ändrats",
      changeAttributes: "Ändra attribut",
      deactivatedSuccessMessage: "Användaren är inaktiverad",
    },
    csv: {
      custom: "Fyll i ett anpassat attribut",
      email: "Fyll i personens e-postadress",
      role: "Fyllnadsnummer: 1 - studerande, 2 - rådgivare",
      gender: "Fyllnadsnummer: 1 - man, 2 - kvinna, 3 - annan",
      year: "Födelseår",
      month: "Födelsemånad (nummer)",
      day: "Födelsedag",
      nameSurname: "Fyll i personens namn och efternamn",
      dateOfBirth: "Födelsedatum: yyyymmdd",
      fillNumber: "Ange nummer",
      workSheetName: "Blad 1",
    },
    csvFields: {
      custom: "Anpassat attribut",
      email: "E-post ",
      role: "Roll",
      gender: "Kön",
      year: "Födelseår",
      month: "Födelsemånad",
      day: "Födelsedag",
      nameSurname: "Namn och efternamn",
      dateOfBirth: "Födelsedatum",
      fillNumber: "Fyll nummer",
      workSheetName: "Ark1",
      attribute: "Attribut",
    },
    csvFieldsValidationMessages: {
      dateOfBirth: "Födelsedatum måste vara i formatet yyyymmdd",
      dateOfBirthRequired: "Födelsedatum krävs",
      attributeRequired: "{{attributes}} krävs",
      nameSurnameInvalid: "namnet är ogiltigt",
    },
    usersOrganization: "{{name}} Användare",
    addUserButton: "Lägg till användare",
    about: "Om mig",
    user: {
      role: "Roll",
      email: "E-postadress",
      status: "Status",
      forcePassword: "Tvinga lösenord",
      attribute: "Attribut",
      forcePasswordDescription:
        "Om du väljer det här alternativet kommer användaren inte behöva logga in med sitt organisationskonto (SSO) utan kommer att välja ett eget lösenord i Allbry själv vid första inloggningen",
      attributeDescription:
        "Du kan välja ett till flera attribut. \n\nDet betyder att endast elever med minst ett av de valda attributen kan kommunicera med dig. Du kan fortfarande kommunicera med samtliga elever. \nOm du inte väljer några attribut kan alla elever se dig.\n",
      allbryCounsellor: "Allbry rådgivare",
    },
    enterFieldName: "Ange fältnamn (t.ex. klass)",
    result: "{{value}} resultat",
    results: "{{value}} resultat",
    noResults: "Inga resultat",
    day: "Dag",
    month: "Månad",
    year: "År",
    statistic: {
      title: "Statistik",
      calendar: "Kalender",
      today: "Idag",
      last7Days: "Senaste 7 dagarna",
      last30Days: "Senaste 30 dagarna",
      last90Days: "Senaste 90 dagarna",
      thisWeek: "Vecka",
      thisMonth: "Månad",
      thisQuarter: "Kvartal",
      thisYear: "År",
      allTime: "Historiskt",
      userTypes: "Användartyper",
      notFound: "Ingen statistik hittades",
      topics: "Elevrapporter",
      amountOfReports: "Antal rapporter",
      experience: "Orosnivå",
      counselling: "Samtalsbokningar",
      popularTimes: "Populära tider",
      ngoClicks: "Stödlinjer",
      usersAmount: "{{amount}} användare",
      levelOfWorry: "Nivå av oro",
      chats: "Chattar",
      video: "Video",
      other: "Annat",
      appointments: "Samtal",
      all: "Alla",
      without0: "Faktisk oro",
      without0tooltip:
        "Aktiverad: Genomsnittlig orosnivå visas för de samtal där det faktiskt har angivits att det finns en oro. \nAvvaktiverad: Genomsnittlig orosnivå för alla samtal visas även där oro inte upplevts.",
      allTitle: {
        users: "{{value}} användare",
        user: "{{value}} användare",
        times: "{{value}} konversationer",
        time: "{{value}} konversation",
        redirection: "{{value}} hänvisningar",
        redirections: "{{value}} hänvisningar",
      },
      registered: "Registrerade",
      inactive: "Inaktiva",
      active: "Registrerade & aktiva",
      todayInterval: "Idag {{start}} - {{end}}",
      pdfExport: "Exportera som PDF",
      chartTitle: "Samtal",
      student: "Elevstatistisk",
      internal: "Intern EHT statistisk",
      totalHours: "Totalt antal timmar",
      showAll: "Visa allt",
      showLess: "Visa mindre",
      anonymousUsersCount: "Antal anonyma användare - {{count}}",
      selectTopicsCategories: "Välj ämneskategorier",
      includeMeetingKind: "Inkludera manuella rapporter",
      moreThanOneChatCountAverage:
        "Genomsnittligt antal chattar för elever som chattat mer än en gång:",
      oneChatCountPercentage: "Antal elever som endast chattat en gång:",
    },
    internalStatistic: {
      time: "Tid per grupp",
      total: "Totalt",
      hours: "timmar",
    },
    changeAttributesNotes:
      '- Om du vill ändra attribut, välj och visa inmatningsrutan för att skriva din ändring, tryck sedan på "Spara"-knappen för att spara ändringarnarna. \n - Om du bara väljer attribut utan att fylla i ett nytt värde och trycker på "Spara"-knappen kommer du att radera attributet. \n - Om du vill lägga till ett nytt attribut, skriv ditt nya attribut och tryck sedan på "Spara"-knappen. ',
  },
  admin: {
    title: "Allbry Admin",
    modals: {
      addCounsellors: {
        choose: "Välj elevhälsopersonal",
        search: "Sök elevhälsopersonal",
      },
    },
    organization: {
      organizations: "organisationer",
      edit: "Redigera organisationen",
      details: "Uppgifter om organisationen",
      closed: "Stängt",
      start: "Startdatum",
      end: "Slutdatum",
      principal: "Huvudansvarig",
      principals: "Huvudmännen",
      create: "Skapa en organisationen",
      view: "Visa",
      editPopup: "Redigera",
      deactivated: "Organisationen inaktiverad",
      deactivatedError: "Fel vid avaktivering av organisationen",
      name: "Organisationens namn",
      startEnd: "Startdatum/Slutdatum",
      addPrincipal: "+ Lägg till huvudansvarig",
      addCounsellor: "+ Lägg till elevhälsopersonal",
      searchOrganizations: "Sök efter organisationer med namn",
      edited: "Organisationen redigerades framgångsrikt.",
      created: "Organisationen skapades framgångsrikt.",
      createdError: "Fel i att skapa en organisation",
      editError: "Fel i redigeringen av organisationen",
      longName: "För långt namn",
      startDateRequired: "Startdatum krävs",
      endBeforeStart: "Slutdatum kan inte vara före startdatum",
      longEmail: "För långt e-postadress",
      emailFormat: "Fel e-postformat",
      duplicateEmails: "Dubbla e-postmeddelanden",
      userExists: "Användaren finns redan",
      atLeastOne: "Minst en av dem måste vara aktiv.",
      subscriptionType: {
        title: "Subscription types",
        description:
          "Your organization  bla bla description for the feature allows you to be anonymous. Your name and profile image will be hidden from other users",
        addLink: "+ Add feature or type",
        selectType: "Select type",
        registrationCode: "Registration code",
        add: "Add",
        remove: "Remove",
        addDialogTitle: "Add subscription type",
        addSuccess: "Subscription type has been added successfully",
        removeSuccess: "Subscription type has been removed successfully",
      },
      deleteOrganization: "Ta bort organisation",
      requestScrapeSuccess: "Du har tagit bort organisationen",
      scrapeMultipleOrganizationDialogInstruction:
        "Du kommer att ta bort följande organisation",
    },
    role: {
      title: "Roller",
      addRoles: "+ Lägg till roll",
      createRole: "Skapa roll",
      editRole: "Ändra roll",
      chooseMasterRole: "Välj master roll",
      enterNameRoleSwedish: "Ange namn på roll svenska",
      enterNameRoleEnglish: "Ange namnet på rollen engelska",
      chooseFeatures: "Välj funktioner",
      selectMasterRole: "Välj master roll",
      customRolesCreated: "Rollen är skapad",
      errorCreatecustomRoles: "Fel vid skapandet av rollen",
      updatedcustomRoles: "Rollen är uppdaterad",
      errorUpdatingcustomRoles: "Fel vid uppdatering av rollen",
      removecustomRoles: "Rollen är borttagen",
      errorRemovingcustomRoles: "Fel vid borttag av rollen",
      confirmRemovecustomRoles: "Är du säker på att du vill ta bort rollen?",
      rolesRequired: "Roller är obligatoriskt",
      rolesSelectRequired: "Skapa minst en roll",
      chooseFeaturesOne: "Välj minst en funktion",
      sessionTimeRequired: "Sessionstid krävs",
      sessionTimeNumber: "Sessionstiden ska vara nummer",
      sessionTimeMin: "Sessionstiden bör vara längre än 1 timme",
      sessionTimeTitle: "Sessionstid",
    },
    counsellors: {
      title: "Kurator i Allbry",
      add: "Lägg till kurator",
      edit: "Redigera kurator",
      profile: "Personalens profil",
      searchCounsellors: "Sök efter rådgivare med namn",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
      selectOrganizations: "Select Organization",
      runCron: "Run Now",
      cronRunStart:
        "Data migration process started for the selected organization. You will be received an email shortly",
    },
    configData: {
      title: "Config Data",
      addConfig: "Add Config",
      organization: "Organization",
      migrationTime: "Migration Time",
      status: "Status",
      active: "Active",
      deactivate: "Deactivated",
      viewProfile: "View Config",
      editProfile: "Edit Config",
      organizationActivated: "Organization Activated",
      organizationDeactivated: "Organization Deactivated",
      activatingError: "Error activating Organization",
      deactivatingError: "Error deactivating Organization",
      configDetails: "{{organization}}'s Config Details",
      timerNotSet: "Timer Not Set",
      yes: "Yes",
      no: "No",
    },
    configForm: {
      title: "Config Form",
      addOrgConfig: "Add organization Config",
      editOrgConfig: "Edit organization Config",
      ftpConfigDetails: "FTP Config Details",
      organization: "Organization",
      runOnce: "Run Single Time",
      timer: "Timer",
      daily: "Every Midnight",
      weekly: "Every Sunday Midnight",
      monthly: "Every 1st Of Month Midnight",
      selectTimer: "Select Timer",
      subOrganization: "Sub Organization",
      addOrganization: "+ Add Organization",
      selectOrganizations: "Select Organization",
      userModel: "User Models",
      addModel: "+ Add Model",
      student: "Student",
      attribute: "Attribute",
      userAttributes: "User Attribute",
      addAttribute: "+ Add Attribute",
      selectAttributes: "Select Attribute",
      name: "Name",
      code: "Code",
      host: "Host Name",
      username: "Username",
      password: "Password",
      port: "Port",
      secure: "Secure",
      fileName: "File Name",
      fileFormat: "File Format",
      filePath: "File Path",
      true: "True",
      false: "False",
      fileNameEx: 'Ex: File name is "latest" or create \nyour custom file name',
      filePathEx: 'Ex: File path is "/"  ',
      userModelNameEx: 'Ex: name is "student/counsellor"',
      userModelCodeEx: 'Ex: code is "student/counsellor"',
      edit: "Edit Config",
      nameRequired: "Name is required",
      codeRequired: "Code is required",
      selectRequired: "Select any one",
      configRequired: "{{name}} is required",
    },
    notifications: {
      notificationDate: "Datum",
      title: "Notifikationer",
      message: "Meddelande",
      activeInactive: "Aktiv / Inaktiv",
      status: "Status",
      all: "Alla",
      sent: "Skickat",
      upcoming: "Kommande",
      vieweditNotifications: "Se / ändra notis",
      deleteNotifications: "Ta bort notis",
      createNotification: "Skapa notis",
      notificationDateAndTime: "Datum och tid",
      notificationMessage: "Meddelande",
      notificationMessagePlaceholder: "Ange ett aviseringsmeddeland",
      allOrganization: "Alla organisationer",
      selectOrganization: "Välj organisation",
      add: "Lägg till",
      popup: "Är du säker på att du vill ta bort notisen?",
      selectRequired: "Välj minst en organisation",
      messageValidation: "Meddelandet får inte vara tomt",
      createdNotification: "Notisen är skapad",
      removeNotification: "Notisen är borttagen",
      editNotification: "Notisen är ändrad",
      errorCreateNotification: "Fel vid skapandet av notisen",
      errorErrorNotification: "Fel vid ändring av notisen",
    },
    superActions: {
      title: "Super Actions",
      userLoginWithEmail: "Logga in med e-postadress",
      loginButton: "Logga in",
      emailInput: "E-postadress",
    },
    broadcastMessages: {
      createdBroadcastMessage: "Sändningsmeddelande skapades framgångsrikt",
      updatedBroadcastMessage: "Broadcast-meddelandet har uppdaterats",
      removedBroadcastMessage: "Broadcast-meddelandet har tagits bort",
      deleteBroadcastMessageConfirmation:
        "Är du säker på att du vill radera denna post?",
      deleteBroadcastMessageError:
        "Du kan inte radera denna post men kan avaktivera den",
      editBroadcastMessage: "Redigeringen av sändningsmeddelandet lyckades",
      errorCreateBroadcastMessage:
        "Ett fel uppstod när sändningsmeddelandet skapades",
      errorUpdateBroadcastMessage: "Fel vid uppdatering av sändningsmeddelande",
      errorRemoveBroadcastMessage:
        "Fel när sändningsmeddelandet skulle tas bort",
      allOrganizations: "Alla organisationer",
      selectOrganization: "Välj Organisation",
      active: "Aktiva",
      inActive: "Inaktiv",
      edit: "Redigera",
      delete: "Radera",
      create: {
        startDate: "Start datum",
        endDate: "Slutdatum",
        enterHeading: "Ange rubrik",
        message: "Ange meddelande",
        newsAndMarketingMessage: "Nyheter och marknadsföringsmeddelande",
        add: "Lägg till",
        heading: "Rubrik",
        userTypes: "Användartyper",
        selectUserTypes: "Välj Användartyp",
      },
      userTypes: {
        counsellor: "Rådgivare",
        student: "Studerande",
      },
      listingColumn: {
        heading: "Rubrik",
        message: "Meddelande",
        startDate: "Start datum",
        endDate: "Slutdatum",
        userType: "Användartyp",
        status: "Status",
      },
    },
  },
  allbryCounsellor: {
    choose: "Välj organisation",
    notFound: "Ingen organisation hittad...",
    text: "Du har inte lagts till i någon organisation ännu.",
    error: "Fel när du försöker logga in i organisationen",
  },
  filterModal: {
    filter: "Filter",
    addFilter: "Lägg till filter",
    description: "Visa användare som uppfyller alla villkor:",
    addCondition: "+ Lägg till fler",
    is: "är",
    isNot: "är inte",
    chooseFilter: "Välj filter",
    conditionValue: "Ange villkorets värde",
  },
  counsellorReport: {
    tabs: {
      reportTemplates: "Rapportmallar",
      reports: "Rapporter",
      customReports: "Anpassade rapporter",
    },
    reports: "Rapporter",
    reportTemplate: {
      studentReport: "Elevrapport",
      studentReportDescription: "Skapa en elevrapport",
      studentNote: "Minnesanteckning",
      studentNoteDescription: "Skapa en minnesanteckning för en elev",
      internalReport: "EHT rapport",
      internalReportDescription: "Skapa en intern EHT rapport",
      anonymousReport: "Anonym elevrapport",
      anonymousReportDescription: "Skapa en anonym elevrapport",
    },
    internalReport: {
      selectTypes: "2. Välj typ av möte",
      selectFilter: "3. Välj grupp om relevant (ej obligatorisk)",
      meetingDuration: "5. Mötets varaktighet (i timmar)",
      meetingNotes: "4. Skriv en kort sammanfattning av mötet",
      meetingNoteTitle: "Anteckningar",
      meetingTypes: {
        type1: "EHT",
        type2: "EHM",
        type3: "Samverkanssmöte SIP",
        type4: "Samverkansmöte med VH, skolpersonal med flera",
        type5: "Samverkanssmöte BUP",
        type6: "Samtal med VH, elever & annan aktör",
        type7: "Samtal med elev och VH",
        type8: "Samtal med VH",
        type9: "Samtal med elev och skolpersonal",
        type10: "Samtal med VH och annan aktör",
        type11: "Mötessamverkan",
        type12: "Närvaroarbete",
        type13: "Handledning av skolpersonal",
        type14: "Möte med skolpersonal",
        type15: "Möte med rektor",
        type16: "Medverkan i utvecklingsarbete",
        type17: "Medverkan i trygghetsarbete",
        type18: "Arbete med elevgrupp",
      },
      staticAttributes: {
        attributeName: {
          attribute1: "Stadie",
        },
        attributeValue: {
          attribute1value1: "Lågstadie",
          attribute1value2: "Mellanstadie",
          attribute1value3: "Högstadie",
          attribute1value4: "Gymnasie",
        },
      },
    },
    anonymousReport: {
      title: "Anonym elevrapport",
      selectAttributeTitle: "1. Välj klass/årskurs (valfritt)",
      noAttributes:
        "Inga attribut hittades. Kontakta din administratör för att lägga till attribut.",
      gender: "2. Könsidentitet (ej obligatoriskt)",
      studentName: "3. Ange elevens namn (ej obligatoriskt)",
    },
    chooseStudent: "Välj elev",
    chooseCustomStudent: "Välj {{label}}",
    createReport: "Skapa elevrapport",
    createNote: "Skapa minnesanteckning",
    searchStudents: "Sök efter elev",
    filterOption: {
      notes: "Anteckningar",
      quickReport: "Elevrapporter",
      internalReport: "Interna rapporter",
      anonymousReport: "Anonyma rapporter",
    },
    showMore: "Visa mer...",
  },
  survey: {
    introStep: "Hej, låt oss börja med två snabba frågor!",
    firstStep: {
      question: "Är det första gången du använder Allbry?",
      letMeIn: "Nej, jag har använt Allbry förut",
      whatIsAllbry: "Ja, det är första gången",
    },
    secondStep: {
      question: "Har du sökt stöd tidigare?",
      yes: "Ja, minst ett par gånger",
      never: "Nej, det har jag inte",
    },
    genderStep: {
      question: "Med vilket kön identifierar du dig mest?",
      male: "Man",
      female: "Kvinna",
      other: "Annat",
      private: "Vill inte svara",
    },
    outroStep: "Tack för din tid!",
    helpImprove: "Det kommer bara ta en minut och frågorna är helt anonyma!",
    firstPart: "1/2",
    secondPart: "2/2",
    page: "Sida",
    checkInAndSurvey: "Tempen",
    tabOption: {
      template: "Mallar",
      active: "Aktiva",
      statistics: "Statistik",
    },
    create: {
      title: "Skapa mall",
      name: "Namn",
      accessType: "Åtkomsttyp",
      accessTypeOptions: {
        global: "Global",
        local: "Lokal",
      },
      surveyType: "Undersökningstyp",
      surveyTypeOptions: {
        checkIn: "Check-in",
        survey: "Enkät",
      },
      isPublic: "är offentlig",
      isActive: "Är aktiv",
    },
    createConfig: {
      title: "Konfigurationsmallar",
      Survey: "Enkätmall",
      Account: "Organisation",
      attributes: "Attribut",
      select: "-Välj-",
      runsDay: "Kör varje dag",
      runsWeekly: "Kör varje",
      runsMonthly: "Kör varje {{date}}:e i månaden",
      timerOption: {
        daily: "Dagligen",
        weekly: "Varje vecka",
        monthly: "En gång i månaden",
        weekDays: {
          monday: "Måndag",
          tuesday: "Tisdag",
          wednesday: "Onsdag",
          thursday: "Torsdag",
          friday: "Fredag",
          saturday: "Lördag",
          sunday: "Söndag",
        },
      },
      modals: {
        students: {
          title: "Eget urval",
          chooseStudentTitle: "Vilka vill du ta tempen på?",
          selectedStudents: "Valda elever",
          confirmSelection: "Bekräfta urval",
          searchPlaceholder: "Sök efter elev",
          noStudentsFound: "Inga elever hittades",
        },
      },
      addOwnUsers: "+ Lägg till dina egna användare",
      addedOwnUsers: "Lade till {{count}} egna användare",
    },
    template: {
      createTemplate: "Mall skapades",
      errorCreateTemplate: "Fel när mallen skapades",
      deleteTemplate: "Mallen har tagits bort",
      deleteTemplateConfirmation:
        "Är du säker på att du vill ta bort denna mall ?",
      deleteTemplateError:
        "Du kan inte ta bort den här mallen men kan avaktivera den",
      deleteConfigError:
        "Du kan inte ta bort den här konfigurationen men kan avaktivera den",
      errorDeleteTemplate: "Fel vid borttagning av mall",
      editTemplate: "Mallredigering lyckades",
      errorEditTemplate: "Fel vid redigering av mall",
      createConfig: "Tempen skapades framgångsrikt",
      errorCreateConfig: "Fel när konfigurationen skapades",
      active: "aktiva",
      inActive: "inaktiv",
      true: "Sann",
      false: "falsk",
      timer: "Timer",
      RunOnce: "Kör en gång",
      StartTime: "Starttid",
      EndTime: "Sluttid",
      TimeLimitInHour: "Tidsgräns i timme",
      editTemplate: "Mallredigering lyckades",
      errorEditTemplate: "Fel vid redigering av mall",
      typeChangeDescription:
        "Vi ser att du har några ändringar på undersökningsmallar.\n Är du säker på att du vill ändra?\n Om du ändrar undersökningstyp kommer alla ändringar att ignoreras.",
      active: "aktiva",
      inActive: "inaktiv",
      btn: {
        delete: "Ta bort",
        edit: "Redigera",
        statistics: "Statistik",
        addImage: "Bild till frågan",
      },
      listingColumn: {
        name: "Namn",
        accessType: "Åtkomsttyp",
        surveyType: "Undersökningstyp",
        public: "Offentlig",
        questionAmount: "Frågebelopp",
        status: "Status",
        attributes: "Användarattribut",
        organization: "organisations namn",
        isAnonymous: "är anonym",
        action: "Handling",
        StartDate: "Start datum",
        EndDate: "Slutdatum",
      },
      questionType: {
        filling: "Allbry",
        rangSlider: "Range slider",
        singleSelect: "Enstaka val",
        image: "Bild",
      },
      createTemplateAboutDescription:
        "Se videon nedan för instruktioner om hur du skapar en mall",
      createTemplateAboutTitle: "Beskrivning",
      duplicate: "Duplicera",
      copyText: "Kopiera",
      addImages: "Lägg till bilder",
    },
    student: {
      question: "Fråga",
      stripMas: "Din skola vill ta tempen!!",
      questionnaire: "Enkät",
      completeHeading: "Tack för dina svar!",
      completeDescription: "Enkäten har skickats in.",
      completeBackButton: "Tillbaka till hemskärmen",
      startSurvey: "Påbörja enkäten",
      skipQuestion: "Jag vill inte svara",
      SkipMas: "Är du säker på att du inte vill svara?",
      notAnonymousAnswerDescription:
        "Enkäten är inte anonym och elevhälsan kan ta del av individuella svar",
    },
    statistics: {
      noAnyTemplate: "Du har inga mallar",
      all: "Alla",
      ended: "Avslutad",
      started: "Startad",
      date: "Datum",
      AmountOfAnswers: "Antal svar",
      noOFUsers: "Antal elever",
      question: "frågor",
      thisMonth: "Denna månad",
      unanswered: "Obesvarad",
      status: {
        new: "Ny",
        complete: "Avslutad",
        active: "Aktiv",
      },
      showAll: "Visa allt",
      showLess: "Visa mindre",
      response: "svar",
      days: "dagar",
      weekNumbers: "Veckans nummer",
      months: "månader",
      students: "Elever",
      noAnyoneAnswered: "Inga elever har besvarat denna enkät än",
      answer: "Svar",
      deepFilter: "Djupfiltrering",
      averageValue: "Medelvärde: {{value}}",
      multiple: "(Flera olika)",
      guestUserLink: "Gästanvändarlänk",
      showGuestUserData: "Visa gästanvändardata",
      guestUsers: "gästanvändare",
      filterInfo: "Om ett filter tillämpas så visas inte gästanvändardata",
      showGuestUserDataDisabledContent:
        "Det går inte att visa gästanvändardata om ett filter tillämpas.",
      amountOfCustomStudents: "Manuellt valda elever",
      numberOfCustomStudents: "Antal manuellt valda elever",
      anonymousResponse: "Svar #{{number}}",
      responses: "Svar",
      students: "Elever",
      noAnyoneAnswered: "Ingen har svarat än",
    },
    counsellor: {
      titles: { survey: "Enkät", checkIn: "Check-in" },
      readMoreDifferenceModalTitle: "Skillnad",
      checkInDescription:
        "En återkommande enkät med frågor som ställs med jämna mellanrum enligt valt tidsintervall. Den används för att kontinuerligt samla in data, identifiera trender och följa förändringar över tid. Perfekt för att mäta elevernas välmående eller andra faktorer som kräver regelbunden uppföljning. Genom att analysera resultaten över tid kan insikter skapas som bidrar till bättre beslutsfattande och långsiktig utveckling.",
      surveyDescription:
        "En engångsenkät med frågor som ställs vid ett specifikt tillfälle. Den används för att snabbt samla in information, utvärdera en händelse eller få en ögonblicksbild av elevernas åsikter och upplevelser. Passar bra för trygghets- och trviselenkäter, skolenkäter eller utvärderingar där en enda datainsamling är tillräcklig. Resultaten kan ge värdefulla insikter för att fatta beslut eller förbättra framtida processer.",
      title: "Temperaturkollen",
      startTitle: "Ta tempen på dina elever",
      startDescription:
        "Med temperaturkollen kan du skicka ut långa eller korta frågeformulär för att lära dig mer om dina elevers välmående.",
      createTemplateBtn: "Skapa din första temp",
      addTemplateBtn: "Skapa ny temp",
      readMoreDifference: "Läs mer om skillnaden",
      student: "elever",
      ownSelection: "Eget urval",
      ownSelectionDescription: "Välj enskilda personer",
      answered: "Svarade",
      dispatch: "Utskicksfrekvens",
      adjustTime: "Anpassa datum och tid",
      question: {
        num1: "Vill du ta tempen eller skapa en enkät?",
        template: "Vad vill du ta tempen på?",
        attribute: "Vilka vill du ta tempen på?",
        survey: "När vill du skicka ut enkäten?",
        checkIn: "Hur ofta vill du ta tempen?",
        description: {
          checkIn:
            "En återkommande enkät med frågor som ställs med jämna mellanrum enligt valt tidsintervall",
          survey:
            "En engångsenkät med frågor som ställs vid ett specifikt tillfälle",
        },
        anonymousPageTitle: "Vill du se individuella svar?",
        anonymousPageDescription:
          "Om du aktiverar detta så kommer du att kunna se elevernas individuella svar, dock kommer eleverna att informeras när enkäten startar att deras svar inte kommer att vara anonyma.",
        guestPageTitle: "Vill du skapa en enkätlänk?",
        guestPageDescription:
          "Om du aktiverar detta får du en länk och/eller QR-kod som du kan dela ut till elever, vårdnadshavare eller andra som INTE har Allbry. \n Personerna som sedan använder länken kommer att kunna svara på enkäten utan att logga in och/eller ha ett konto. Funktionen går att kombinera med klasser/årskurse samt att se individuella svar för dessa.",
      },
      status: {
        active: "Aktiva",
        search: "Sök",
        completed: "Avslutade",
      },
      timerOption: {
        daily: "Dagligen",
        weekly: "Veckovis",
        monthly: "Månadsvis",
        dailyDescription: "Skickas varje dag",
        weeklyDescription: "Skickas varje måndag",
        monthlyDescription: "Skickas den 1a varje månad",
      },
      createOwnTemplate: "+ Skapa en egen mall",
    },
    templateType: {
      general: "Allmänna",
      private: "Egna",
    },
    surveyTypeOptions: {
      checkIn: "Check-in",
      survey: "Enkät",
    },
    amountQuestion: "Antal frågor",
    endSurveyConfig: "Avsluta enkäten",
    endSurveyPopupConfirmationText: "Är du säker på att du vill avsluta?",
    endSuccess: "Enkäten har avslutats",
    deleteSurveyConfig: "Ta bort enkät",
    deleteSurveyConfigPopupConfirmationText:
      "Är du säker på att du vill ta bort enkäten och enkätsvaren?",
    deleteSurveyConfigPopupConfirmationBody:
      "Observera att även enkätsvaren kommer att försvinna, åtgärden kan inte ångras.",
    editorLabels: {
      designer: "Designer",
      preview: "Förhandsgranska",
    },
  },
  customReports: {
    title: "Anpassade rapporter",
    description:
      "Här kan du välja att aktivera och/eller skapa egna rapportmallar om du saknar något i våra existerande. På samma sätt som med elevrapporten så generaras grafer och statistik utifrån de svar som personalen har gett. Du kan även välja att skapa en anonym rapport där ingen av elevernas svar går att spåra tillbaka till dem.",
    createReportBtn: "Skapa en anpassad rapport",
    template: {
      title: "Skapa mall",
      type: {
        general: "Allmän",
        private: "Egna",
      },
      duplicate: "Duplicera",
      copyText: "Kopiera",
      name: "Namn",
      namePlaceholder: "Vänligen ange namn",
      description: "Beskrivning",
      descriptionPlaceholder: "Vänligen ange beskrivning",
      accessTypeLabel: "Åtkomsttyp",
      accessTypePlaceholder: "Välj åtkomsttyp",
      accessType: {
        global: "Global",
        local: "Lokal",
      },
      public: "Offentlig",
      active: "Aktiv",
      createTemplateAboutTitle: "Beskrivning",
      createTemplateAboutDescription:
        "Se videon nedan för instruktioner om hur du skapar en mall",
      createTemplateSuccess: "Mall skapades framgångsrikt",
      errorCreateTemplate: "Fel när mallen skapades",
      updateTemplateSuccess: "Mallredigering lyckades",
      errorUpdateTemplate: "Fel vid redigering av mall",
      deleteTemplateConfirmation:
        "Är du säker på att du vill ta bort denna mall?",
      createTemplateSecretLevelConfirmationLow:
        "Är du säker på att du vill aktivera rapporten med låg sekretessnivå?",
      createTemplateSecretLevelConfirmationHigh:
        "Är du säker på att du vill aktivera rapporten med hög sekretessnivå?",
      createTemplateSecretLevelDescription:
        "Följande roller kommer att ha tillgång till rapporttypen: {{description}}",
      deleteTemplateSuccess: "Mallen har tagits bort",
      errorDeleteTemplate: "Fel vid borttagning av mall",
      confirmDialog: {
        editTemplate: {
          header: "Är du säker på att du vill redigera den här mallen?",
          body: "Om du redigerar mallen...",
        },
      },
    },
    statistics: {
      selectTemplate: "Fler rapporttyper",
      users: "Användare",
      allReports: " Alla rapporter",
      normalReport: "Normal rapport #{{number}}",
      anonymousReport: "Anonym rapport #{{number}}",
      resultAdditionalInfo: {
        dateAndTime: "Datum och tid",
        user: "Användare",
        reporter: "Rapportör",
      },
    },
    config: {
      screen1: {
        title: "Välj mall eller skapa egen",
        createTemplate: "Skapa din egen mall",
      },
      screen2: {
        title: "Roller med tillgång",
        person: "{{count}} person",
        persons: "{{count}} personer",
      },
      screen3: {
        title: "Vill du tillåta anonyma rapporter?",
        allowAnonymousReportsDescription:
          "Om du aktiverar detta kommer användare att kunna skapa anonyma rapporter. Med det menas att personalen inte behöver markera en elev när den använder rapporten.",
      },
      screen4: {
        title: "Välj sekretessnivå",
        high: "Hög",
        low: "Låg",
        allowPriorityDescription:
          "Ni behöver välja sekretessnivå för rapporttypen ni skapat. Valet av sekretessnivå avgör hur rapporter kan delas inom personalgruppen. <br><br> En hög sekretessnivå begränsar åtkomsten till individuella elevsvar och visar endast anonymiserad statistik för yrkesroller som inte valts specifikt. Fritextsvar döljs helt, då dessa kan innehålla identifierande information. Denna nivå passar när endast särskilt ansvariga professioner ska hantera känsliga uppgifter. <br><br> En låg sekretessnivå innebär att hela personalgruppen får tillgång till fullständiga rapporter, inklusive individuella svar och elevnamn. Även fritextsvar visas, vilket ger större transparens men också kräver noggrannhet i hanteringen av personuppgifter.",
        highPriorityDescription:
          "En hög sekretessnivå innebär att enskilda rapporter inte är synliga för all personal. Endast de yrkesroller som valdes i föregående steg får tillgång till individuella svar. Övrig personal kan endast ta del av sammanställd statistik, och då utan koppling till enskilda elever. Dessutom visas ingen statistik från fritextsvar, eftersom dessa kan innehålla uppgifter som kan identifiera en elev.",
        lowPriorityDescription:
          "En låg sekretessnivå innebär att all personal får tillgång till individuella svar i rapporterna, inklusive information om vilka elever rapporterna gäller. Det innebär att inga begränsningar sätts på vilka yrkesroller som får se innehållet. Även fritextsvar blir synliga, vilket kan innebära att personligt identifierbara uppgifter förekommer. Denna nivå kan vara lämplig i sammanhang där ett helt team behöver full insyn för att kunna ge rätt stöd.",
      },
      createSuccess: "Rapporten har skapats",
      errorCreateConfig: "Fel när rapporten skapades",
      updateSuccess: "Rapporten har uppdaterats",
      errorUpdateConfig: "Fel vid uppdatering av rapport",
      list: {
        all: "Alla",
        reports: "{{count}} Rapporter",
      },
      amountOfQuestions: "Antal frågor",
      amountOfReports: "Antal rapporter",
      roles: "Roller",
      editRoles: "Redigera roller",
      editTemplate: "Redigera mall",
      rolesUpdateSuccess: "Roller har uppdaterats",
      errorRolesUpdate: "Fel vid uppdatering av roller",
      warningDialogForNotEligibleToEditTemplate: {
        header: "Du kan inte redigera den här mallen",
        body: "Du kan inte redigera den här mallen eftersom du inte är berättigad att redigera den här mallen. Kontakta din administratör.",
      },
    },
  },
};

export default sv;
